// signal-to-observable.ts
import { effect } from "@lit-labs/preact-signals";
import { Observable } from "rxjs";
var signalToObservable = (signal) => new Observable(
  (subscriber) => effect(() => {
    subscriber.next(signal.value);
  })
);
export {
  signalToObservable
};
